import React from "react";
import classNames from "classnames";
import { bool, func, shape, string } from "prop-types";

import FieldLabel from "pages/_components/fields/FieldLabel";

const StepperField = (props) => {
    const handleChangeLocal = (event) => {
        const newValue = event.target.value;

        const maxValidation = props.max === undefined || parseInt(newValue, 10) <= parseInt(props.max, 10);
        const minValidation = props.min === undefined || parseInt(newValue, 10) >= parseInt(props.min, 10);

        if (newValue === "" || (maxValidation && minValidation)) {
            props.field.onChange(event);

            if (props.handleChange) {
                props.handleChange(event);
            }
        }
    };

    return (
        <div className={classNames("form-group", props.className)}>
            {!props.hideLabel && !props.label && (
                <FieldLabel idField={props.field.name} labelKey={`${props.idForm}.${props.field.name}.label`} />
            )}
            {!props.hideLabel && props.label && <FieldLabel idField={props.field.name} labelText={props.label} />}
            <div className={classNames("input-group", { "is-disabled": props.disabled })}>
                <input
                    {...props.field}
                    value={props.field.value || ""}
                    className="form-control"
                    name={props.field.name}
                    max={props.max}
                    min={props.min}
                    onChange={handleChangeLocal}
                    type="number"
                    disabled={props.disabled}
                />
            </div>
        </div>
    );
};

StepperField.propTypes = {
    field: shape({
        name: string,
        value: string,
    }).isRequired,
    handleChange: func,
    hideLabel: bool,
    label: string,
    idForm: string.isRequired,
    className: string,
    max: string,
    min: string,
};
StepperField.defaultProps = {
    handleChange: null,
    hideLabel: false,
    label: null,
    className: "",
    max: undefined,
    min: undefined,
};

export default StepperField;
